import { render } from "./BankForm.vue?vue&type=template&id=5568d8e3&scoped=true&ts=true"
import script from "./BankForm.vue?vue&type=script&lang=ts"
export * from "./BankForm.vue?vue&type=script&lang=ts"

import "./BankForm.vue?vue&type=style&index=0&id=5568d8e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5568d8e3"],['__file',"src/components/payoutAccounts/BankForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5568d8e3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5568d8e3', __exports__)) {
    api.reload('5568d8e3', __exports__)
  }
  
  module.hot.accept("./BankForm.vue?vue&type=template&id=5568d8e3&scoped=true&ts=true", () => {
    api.rerender('5568d8e3', render)
  })

}


export default __exports__